import { atom } from "recoil";
import ExcursionModel from "../Models/excursion.model";

export const ExcursionAtom = atom({
  key: "ExcursionAtom",
  default: new ExcursionModel(),
});
